module.exports = __webpack_public_path__ + "static/media/4.3bcbe3c2.jpg";